import TextField from '@Fields/TextField';
import SelectField from '@Fields/SelectField';
import LocationPickerField from '@Fields/LocationPickerField';
import { validateLocation } from '@Utilities/LocationValidator';

class ListingDetailLivestockForm extends React.Component {

    constructor(props) {
        super(props);

        this.state = ListingDetailLivestockForm.modelToState(props);
        this.handleFieldChanged = this.handleFieldChanged.bind(this);
        this.handleOnBlurUpdateXML = this.handleOnBlurUpdateXML.bind(this);
        this.validatorLivestockDetails = this.validatorLivestockDetails.bind(this);
        this.UpdateSpecList = this.UpdateSpecList.bind(this);
        this.UpdateParentState = this.UpdateParentState.bind(this);
        this.SaveToXML = this.SaveToXML.bind(this);

        //updates the parent's validator to use this method
        var parentState = this.props.parentState;
        parentState.validatorLivestockDetails = this.validatorLivestockDetails;
        this.props.handleFormUpdate(parentState);
    }

    componentWillReceiveProps(Props) {
        this.setState({
            IsRegisteredUser: Props.parentState.IsRegisteredUser,
            EmailVerified: Props.parentState.ContactViewModel ? Props.parentState.ContactViewModel.EmailVerified : false
        });
    }

    static modelToState(props) {

        return {
            BaseCategory: 4,
            AnimalCategoryID: props.model.AnimalCategoryID,
            AnimalsList: props.model.AnimalsList,
            TypeCategoryID: props.model.TypeCategoryID,
            TypesList: props.model.TypesList,
            ClassCategoryID: props.model.ClassCategoryID,
            ClassList: props.model.ClassList,
            Description: props.model.Description,
            Translations: props.model.Translations,
            QueryString: props.parentState.QueryString,
            IsRegisteredUser: props.parentState.IsRegisteredUser,
            EmailVerified: props.parentState.ContactViewModel ? props.parentState.ContactViewModel.EmailVerified : false,
            HighlightErrors: {},
            FormErrors: [],
            InputErrors: {}
        };
    }

    handleFieldChanged(field, value) {

        var state = this.state;
        delete state.HighlightErrors[field];
        delete state.InputErrors[field];

        state[field] = value
        switch (field) {
            case "AnimalCategoryID":
                if ($(".toggle-details-2").is(":visible")) {
                    AdditionalDetailsToggle(true)
                }
                value = parseInt(value);
                state.ClassCategoryID = 0;
                state.TypeCategoryID = 0;

                if (value != 0) {
                    Spinner.Show($('#pagebody'));
                    var objectToSend = {
                        CategoryID: value
                    };

                    var xhr = new XMLHttpRequest();
                    xhr.onload = function () {
                        var response = JSON.parse(xhr.response);

                        if (response.bIsTypeDependentCategories) {
                            state.TypesList = response.lstCategoryDropDowns;
                            state.ClassList = [];
                        }
                        else {
                            state.ClassList = response.lstCategoryDropDowns;
                            state.TypesList = [];
                        }

                        Spinner.Remove();
                    }.bind(this);

                    xhr.open("POST", '/listinginput/ajax/GetDependentCategories', false);
                    xhr.setRequestHeader("Content-type", "application/json");
                    xhr.send(JSON.stringify(objectToSend));
                }
                else {
                    state.TypesList = [];
                    state.ClassList = [];
                }

                this.SaveToXML(state);
                this.UpdateSpecList(state);
                this.UpdateParentState(state);
                break;
            case "TypeCategoryID":
                if ($(".toggle-details-2").is(":visible")) {
                    AdditionalDetailsToggle(true)
                }
                value = parseInt(value);
                state.ClassCategoryID = 0;

                if (value != 0) {
                    Spinner.Show($('#pagebody'));

                    var objectToSend = {
                        CategoryID: value
                    };

                    var xhr = new XMLHttpRequest();
                    xhr.onload = function () {
                        var response = JSON.parse(xhr.response);
                        state.ClassList = response.lstCategoryDropDowns;

                        Spinner.Remove();
                    }.bind(this);

                    xhr.open("POST", '/listinginput/ajax/GetDependentCategories', false);
                    xhr.setRequestHeader("Content-type", "application/json");
                    xhr.send(JSON.stringify(objectToSend));
                }
                else {
                    state.ClassList = [];
                }

                this.SaveToXML(state);
                this.UpdateSpecList(state);
                this.UpdateParentState(state);
                break;
            case "ClassCategoryID":
                if ($(".toggle-details-2").is(":visible")) {
                    AdditionalDetailsToggle(true)
                }
                this.SaveToXML(state);
                this.UpdateParentState(state);
                this.UpdateSpecList(state);
                break;
            default:
                break;
        }

        this.setState(state)
    }

    handleOnBlurUpdateXML(e) {
        var state = this.state;

        this.UpdateParentState(state);
        this.SaveToXML(state);
    }

    validatorLivestockDetails(bSaveXML) {
        let state = this.state;
        let bHasErrors = false;
        let elementToScrollTo = {};
        let bIsFirstError = true;

        if (state.AnimalCategoryID == 0) {
            state.HighlightErrors.AnimalCategoryID = true;
            state.InputErrors.AnimalCategoryID = "Animal Is Required";
            bHasErrors = true;
            if (bIsFirstError) {
                bIsFirstError = false;
                elementToScrollTo = $('#AnimalCategoryID');
            }
        }

        if (state.TypeCategoryID == 0 && (this.state.AnimalCategoryID == 0 || this.state.TypesList.length > 0)) {
            state.HighlightErrors.TypeCategoryID = true;
            state.InputErrors.TypeCategoryID = "Type Is Required";
            bHasErrors = true;
            if (bIsFirstError) {
                bIsFirstError = false;
                elementToScrollTo = $('#TypeCategoryID');
            }
        }

        if (state.ClassCategoryID == 0) {
            state.HighlightErrors.ClassCategoryID = true;
            state.InputErrors.ClassCategoryID = "Class Is Required";
            bHasErrors = true;
            if (bIsFirstError) {
                bIsFirstError = false;
                elementToScrollTo = $('#ClassCategoryID');
            }
        }

        var locationResult = validateLocation(this.props.parentState.ContactViewModel.LocationViewModel, state.Translations);
        if (locationResult.hasError) {
            state.HighlightErrors.LocationPicker = true;
            state.InputErrors.LocationPicker = locationResult.errorText;
            bHasErrors = true;
            if (bIsFirstError) {
                bIsFirstError = false;
                elementToScrollTo = $('#LocationPicker');
            }
        } else {
            delete state.HighlightErrors.LocationPicker;
            delete state.InputErrors.LocationPicker;
        }

        if (bSaveXML) {
            this.SaveToXML(state);
        }

        this.setState(state);

        if (bHasErrors) {
            ScrollToElement(elementToScrollTo);
        }

        return bHasErrors;
    }

    UpdateSpecList(state) {
        var objectToSend = {
            Category: state.ClassCategoryID,
            QueryString: state.QueryString,
            FormInputs: this.props.parentState.SpecsViewModel.FormInputs
        }

        var xhr = new XMLHttpRequest();
        xhr.onload = function () {
            var response = JSON.parse(xhr.response);

            var parentState = this.props.parentState;
            parentState.SpecsViewModel = response.oSpecsViewModel;
            parentState.SpecsViewModel.InputErrors = {};
            parentState.SpecsViewModel.HighlightErrors = {};
            this.props.handleFormUpdate(parentState);
        }.bind(this);

        xhr.open("POST", '/listinginput/specs/LoadSpecs', true);
        xhr.setRequestHeader("Content-type", "application/json");
        xhr.send(JSON.stringify(objectToSend));
    }

    UpdateParentState(state) {

        var parentState = this.props.parentState;
        parentState.LivestockViewModel.AnimalCategoryID = state.AnimalCategoryID;
        parentState.LivestockViewModel.AnimalsList = state.AnimalsList;
        parentState.LivestockViewModel.TypeCategoryID = state.TypeCategoryID;
        parentState.LivestockViewModel.TypesList = state.TypesList;
        parentState.LivestockViewModel.ClassCategoryID = state.ClassCategoryID;
        parentState.LivestockViewModel.ClassList = state.ClassList;
        parentState.LivestockViewModel.Description = state.Description;

        this.props.handleFormUpdate(parentState);
    }

    SaveToXML(state) {
        var objectToSend = {
            AnimalCategoryID: state.AnimalCategoryID,
            TypeCategoryID: state.TypeCategoryID,
            ClassCategoryID: state.ClassCategoryID,
            Description: state.Description,
            PriceInfoLivestockViewModel: this.props.model.PriceInfoLivestockViewModel
        };

        var xhr = new XMLHttpRequest();
        xhr.open("POST", '/listinginput/details/saveLivestockDetails' + state.QueryString, true);
        xhr.setRequestHeader("Content-type", "application/json");
        xhr.send(JSON.stringify(objectToSend));
    }

    render() {
        var key = 0; //for each .push method that pushs html

        var bIsEquine = false;
        if ((this.props.parentState.CurrentSite == "EquineMarket")) {
            bIsEquine = true;
        }

        var animalddl = [];
        for (var i = 0; i < this.state.AnimalsList.length; i++) {
            animalddl.push({ text: this.state.AnimalsList[i].Text, value: this.state.AnimalsList[i].Value })
        };

        //fill in drop down list
        var typeddl = [];
        for (var i = 0; i < this.state.TypesList.length; i++) {
            typeddl.push({ text: this.state.TypesList[i].Text, value: this.state.TypesList[i].Value })
        };

        var classddl = [];
        for (var i = 0; i < this.state.ClassList.length; i++) {
            classddl.push({ text: this.state.ClassList[i].Text, value: this.state.ClassList[i].Value })
        };

        //Type drop down is only shown if Animal is empty or if the animal selected does not need Types
        var typeDropDownField = [];
        if (this.state.AnimalCategoryID == 0 || this.state.TypesList.length > 0) {
            typeDropDownField.push(
                <div className="form-row cf" key={key}>
                    <label className="label-left" htmlFor="TypeCategoryID">Type  <span>*</span></label>
                    <div className="input-right">
                        <SelectField
                            id="TypeCategoryID"
                            value={this.state.TypeCategoryID}
                            values={typeddl}
                            onFieldChanged={(e) => { this.handleFieldChanged("TypeCategoryID", e); }}
                            error={this.state.HighlightErrors.TypeCategoryID}
                            errorText={this.state.InputErrors.TypeCategoryID}
                            hasLabel={true}
                        />
                    </div>
                </div>
            );

            key = key + 1;
        }

        return (
            <div>
                {/*Animal*/}
                <div className="form-row cf">
                    <label className="label-left" htmlFor="AnimalCategoryID" style={{ display: bIsEquine ? "none" : "block" }}>Animal <span>*</span></label>
                    <div className="input-right" style={{display: bIsEquine ? "none" : "block"}}>
                        <SelectField
                            id="AnimalCategoryID"
                            value={this.state.AnimalCategoryID}
                            values={animalddl}
                            onFieldChanged={(e) => { this.handleFieldChanged("AnimalCategoryID", e); }}
                            error={this.state.HighlightErrors.AnimalCategoryID}
                            errorText={this.state.InputErrors.AnimalCategoryID}
                            hasLabel={true}
                        />
                    </div>
                </div>

                {/*Type*/}
                {typeDropDownField}

                {/*Class*/}
                <div className="form-row cf">
                    <label className="label-left" htmlFor="ClassCategoryID">Class  <span>*</span></label>
                    <div className="input-right">
                        <SelectField
                            id="ClassCategoryID"
                            value={this.state.ClassCategoryID}
                            values={classddl}
                            onFieldChanged={(e) => { this.handleFieldChanged("ClassCategoryID", e); }}
                            error={this.state.HighlightErrors.ClassCategoryID}
                            errorText={this.state.InputErrors.ClassCategoryID}
                            hasLabel={true}
                        />
                    </div>
                </div>

                <div className="form-row cf">
                    <label className="label-left" htmlFor="Description">{this.state.Translations["Description"]}</label>
                    <div className="input-right">
                        <TextField
                            id="Description"
                            type={"textarea"}
                            value={this.state.Description}
                            onFieldChanged={(e) => { this.handleFieldChanged("Description", e); }}
                            onBlur={(e) => { this.handleOnBlurUpdateXML(e); }}
                            characterLimit={50000}
                            error={this.state.HighlightErrors.Description}
                            errorText={this.state.InputErrors.Description}
                            hasLabel={true}
                        />
                    </div>
                </div>

                {/*Location - City, State, Zip*/}
                <LocationPickerField
                    translations={this.state.Translations}
                    locationData={this.props.parentState.ContactViewModel.LocationViewModel}
                    onLocationChanged={(loc) => {
                        var highlightErrors = this.state.HighlightErrors;
                        var inputErrors = this.state.InputErrors;
                        delete highlightErrors.LocationPicker;
                        delete inputErrors.LocationPicker;
                        Object.assign(this.props.parentState.ContactViewModel.LocationViewModel, loc);
                        this.setState({ HighlightErrors: highlightErrors, InputErrors: inputErrors }, () => {
                            this.UpdateParentState(this.state);
                        });
                    }}
                    onValidation={(result) => {
                        var highlightErrors = this.state.HighlightErrors;
                        var inputErrors = this.state.InputErrors;
                        if (result.hasError) {
                            highlightErrors.LocationPicker = true;
                            inputErrors.LocationPicker = result.errorText;
                        } else {
                            delete highlightErrors.LocationPicker;
                            delete inputErrors.LocationPicker;
                        }
                        this.setState({ HighlightErrors: highlightErrors, InputErrors: inputErrors });
                    }}
                    onBlur={() => { this.UpdateParentState(this.state); }}
                    highlightErrors={this.state.HighlightErrors}
                    inputErrors={this.state.InputErrors}
                    showWeeklyUpdateSubscriptionCheckbox={this.props.parentState.ContactViewModel.ShowWeeklyUpdateSubscriptionCheckbox}
                    onReceiveEmailsChanged={(val) => { this.props.parentState.ContactViewModel.ReceiveEmails = val; this.UpdateParentState(this.state); }}
                />
            </div>
        );
    }
}

export default ListingDetailLivestockForm;
global.ListingDetailLivestockForm = ListingDetailLivestockForm;